import { render, staticRenderFns } from "./StatisticDomesticTourism.vue?vue&type=template&id=6718c11a&scoped=true&"
import script from "./StatisticDomesticTourism.vue?vue&type=script&lang=js&"
export * from "./StatisticDomesticTourism.vue?vue&type=script&lang=js&"
import style0 from "./StatisticDomesticTourism.vue?vue&type=style&index=0&id=6718c11a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6718c11a",
  null
  
)

export default component.exports